// eslint-disable-next-line import/no-cycle
import useJwt from '@/auth/jwt/useJwt'
import { accountPermissions, batchPermissions, postingPermissions } from '../../helpers/permissions'

const { axiosIns } = useJwt
// const baseUrl = 'https://sandbox-admin-ms.udara360.io/api'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},

  actions: {
    batchAccountCreation: async (context, formData) => {
      try {
        useJwt.setPermission(batchPermissions.BATCH_ACCOUNT_UPLOAD)
        const response = await axiosIns.post('/accounting/api/CustomerAccount/v1/AddBatchCustomer', formData)
        return Promise.resolve(response)
      } catch (error) {
        return Promise.reject(error)
      }
    },
    batchIndividualCustomer: async (context, formData) => {
      try {
        useJwt.setPermission(batchPermissions.BATCH_ACCOUNT_UPLOAD)
        const response = await axiosIns.post('/accounting/api/CustomerAccount/v1/AddBatchCustomerOnly', formData)
        return Promise.resolve(response)
      } catch (error) {
        return Promise.reject(error)
      }
    },
    batchAccountStatusUpdate: async (context, formData) => {
      try {
        useJwt.setPermission(batchPermissions.BATCH_ACCOUNT_UPDATE)
        const response = await axiosIns.post('/accounting/api/CustomerAccount/v1/BatchAccountUpdate', formData)
        return Promise.resolve(response)
      } catch (error) {
        return Promise.reject(error)
      }
    },
    batchLoanScheduleEditAction: async (context, formData) => {
      try {
        useJwt.setPermission(accountPermissions.MODIFY_PAYMENT_SCHEDULE)
        const response = await axiosIns.post('/accounting/api/LoanAccount/v1/BatchLoanScheduleEdit', formData)
        return Promise.resolve(response)
      } catch (error) {
        return Promise.reject(error)
      }
    },
    batchLoanCreation: async (context, formData) => {
      try {
        useJwt.setPermission(batchPermissions.BATCH_LOAN_UPLOAD)
        const response = await axiosIns.post('/accounting/api/BatchLoanAccount/v1/BatchCreate', formData)
        return Promise.resolve(response)
      } catch (error) {
        return Promise.reject(error)
      }
    },
    validateBatchLoanDisburse: async (context, formData) => {
      try {
        useJwt.setPermission(accountPermissions.VIEW_BATCH_LOAN_DISBURSE)
        const response = await axiosIns.post('/accounting/api/BatchLoanAccount/v1/ValidateBatchDisburse', formData)
        return Promise.resolve(response)
      } catch (error) {
        return Promise.reject(error)
      }
    },
    batchLoanDisburse: async (context, formData) => {
      try {
        useJwt.setPermission(accountPermissions.BATCH_LOAN_DISBURSE)
        const response = await axiosIns.post('/accounting/api/BatchLoanAccount/v1/BatchDisburse', formData)
        return Promise.resolve(response)
      } catch (error) {
        return Promise.reject(error)
      }
    },
    batchLoanTermination: async (context, formData) => {
      try {
        useJwt.setPermission(accountPermissions.REPAY_LOAN)
        const response = await axiosIns.post('/accounting/api/LoanAccount/v1/BatchTerminate', formData)
        return Promise.resolve(response)
      } catch (error) {
        return Promise.reject(error)
      }
    },
    downloadAccountFormat: async (context, typeValue) => {
      try {
        useJwt.setPermission(postingPermissions.VIEW_BATCH_BACKDATING_POSTING)
        const response = await axiosIns.get(`/admin/api/Operations/v1/GetFileUrlByFileType?fileUploadType=${typeValue}`)
        return Promise.resolve(response)
      } catch (error) {
        return Promise.reject(error)
      }
    },
    validateBatchAccountCreation: async (context, formData) => {
      try {
        useJwt.setPermission(batchPermissions.BATCH_ACCOUNT_UPLOAD)
        const response = await axiosIns.post('/accounting/api/CustomerAccount/v1/ValidateBatchAccountAsync', formData)
        return Promise.resolve(response)
      } catch (error) {
        return Promise.reject(error)
      }
    },
    validateBatchLoanCreation: async (context, formData) => {
      try {
        useJwt.setPermission(batchPermissions.BATCH_LOAN_UPLOAD)
        const response = await axiosIns.post('/accounting/api/BatchLoanAccount/v1/ValidateBatchCreate', formData)
        return Promise.resolve(response)
      } catch (error) {
        return Promise.reject(error)
      }
    },
    migrateLoanAccountCreation: async (context, formData) => {
      try {
        useJwt.setPermission(batchPermissions.BATCH_LOAN_UPLOAD)
        const response = await axiosIns.post('/accounting/api/Migration/v1/LoanMigration', formData)
        return Promise.resolve(response)
      } catch (error) {
        return Promise.reject(error)
      }
    },
    validateLoanAccountDataMigration: async (context, formData) => {
      try {
        useJwt.setPermission(batchPermissions.DATA_MIGRATION)
        const response = await axiosIns.post('/accounting/api/Migration/v1/ValidateLoanMigration', formData)
        return Promise.resolve(response)
      } catch (error) {
        return Promise.reject(error)
      }
    },
    migrateLoanScheduleCreation: async (context, formData) => {
      try {
        useJwt.setPermission(batchPermissions.DATA_MIGRATION)
        const response = await axiosIns.post('/accounting/api/Migration/v1/LoanScheduleMigration', formData)
        return Promise.resolve(response)
      } catch (error) {
        return Promise.reject(error)
      }
    },
    validateLoanSheduleDataMigration: async (context, formData) => {
      try {
        useJwt.setPermission(batchPermissions.DATA_MIGRATION)
        const response = await axiosIns.post('/accounting/api/Migration/v1/ValidateLoanScheduleMigration', formData)
        return Promise.resolve(response)
      } catch (error) {
        return Promise.reject(error)
      }
    },
    migrateGlCreation: async (context, formData) => {
      try {
        useJwt.setPermission(batchPermissions.DATA_MIGRATION)
        const response = await axiosIns.post('/accounting/api/Migration/v1/GLMigration', formData)
        return Promise.resolve(response)
      } catch (error) {
        return Promise.reject(error)
      }
    },
    migrateGlBalance: async (context, formData) => {
      try {
        useJwt.setPermission(batchPermissions.DATA_MIGRATION)
        const response = await axiosIns.post('/accounting/api/Migration/v1/GLBalanceMigration', formData)
        return Promise.resolve(response)
      } catch (error) {
        return Promise.reject(error)
      }
    },
    migrateCustomerBalance: async (context, formData) => {
      try {
        useJwt.setPermission(batchPermissions.DATA_MIGRATION)
        const response = await axiosIns.post('/accounting/api/Migration/v1/CustomerBalanceMigration', formData)
        return Promise.resolve(response)
      } catch (error) {
        return Promise.reject(error)
      }
    },
    migrateOverdraftAccountCreation: async (context, formData) => {
      try {
        useJwt.setPermission(batchPermissions.DATA_MIGRATION)
        const response = await axiosIns.post('/accounting/api/Migration/v1/AccountOverdraftMigration', formData)
        return Promise.resolve(response)
      } catch (error) {
        return Promise.reject(error)
      }
    },
    migrateFdAccountCreation: async (context, formData) => {
      try {
        useJwt.setPermission(batchPermissions.DATA_MIGRATION)
        const response = await axiosIns.post('/accounting/api/Migration/v1/FixedDepositMigration', formData)
        return Promise.resolve(response)
      } catch (error) {
        return Promise.reject(error)
      }
    },
    migrateGroupMemberMapping: async (context, formData) => {
      try {
        useJwt.setPermission(batchPermissions.DATA_MIGRATION)
        const response = await axiosIns.post('/accounting/api/CustomerAccount/v1/BatchUploadGroupMemberAsync', formData)
        return Promise.resolve(response)
      } catch (error) {
        return Promise.reject(error)
      }
    },
    validateGroupCustomerAccountCreation: async (context, formData) => {
      try {
        useJwt.setPermission(batchPermissions.DATA_MIGRATION)
        const response = await axiosIns.post('/accounting/api/CustomerAccount/v1/ValidateBatchGroupAccountAsync', formData)
        return Promise.resolve(response)
      } catch (error) {
        return Promise.reject(error)
      }
    },
    groupCustomerAccountCreation: async (context, formData) => {
      try {
        useJwt.setPermission(batchPermissions.DATA_MIGRATION)
        const response = await axiosIns.post('/accounting/api/CustomerAccount/v1/AddBatchGroupCustomer', formData)
        return Promise.resolve(response)
      } catch (error) {
        return Promise.reject(error)
      }
    },
    validateCorporateAccountCreation: async (context, formData) => {
      try {
        useJwt.setPermission(batchPermissions.DATA_MIGRATION)
        const response = await axiosIns.post('/accounting/api/CustomerAccount/v1/ValidateBatchCorporateAccountAsync', formData)
        return Promise.resolve(response)
      } catch (error) {
        return Promise.reject(error)
      }
    },
    corporateAccountCreation: async (context, formData) => {
      try {
        useJwt.setPermission(batchPermissions.DATA_MIGRATION)
        const response = await axiosIns.post('/accounting/api/CustomerAccount/v1/AddBatchCorporateCustomer', formData)
        return Promise.resolve(response)
      } catch (error) {
        return Promise.reject(error)
      }
    },
    accountOfficerReassignmentAction: async (context, { formData, permission }) => {
      try {
        useJwt.setPermission(permission)
        const response = await axiosIns.put('/accounting/api/AccountOfficer/v1/BatchAccountOfficerReassignment', formData)
        return Promise.resolve(response)
      } catch (error) {
        return Promise.reject(error)
      }
    },
  },
}
